'use client';

import { __styles, mergeClasses } from "@griffel/react";
import { tokens } from "@fluentui/react-theme";
export const colorPickerClassNames = {
  root: 'fui-ColorPicker'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  root: {
    mc9l5x: "f22iagw",
    Beiy3e4: "f1vx9l62",
    i8kkvl: 0,
    Belr9w4: 0,
    rmohyg: "f7e3wsx"
  }
}, {
  d: [".f22iagw{display:flex;}", ".f1vx9l62{flex-direction:column;}", [".f7e3wsx{gap:var(--spacingVerticalXS);}", {
    p: -1
  }]]
});
/**
 * Apply styling to the ColorPicker slots based on the state
 */
export const useColorPickerStyles_unstable = state => {
  const styles = useStyles();
  // eslint-disable-next-line react-hooks/immutability
  state.root.className = mergeClasses(colorPickerClassNames.root, styles.root, state.root.className);
  return state;
};